module.exports = __webpack_public_path__ + "static/media/bg-tablet.85ba4df9.jpg";